import React from "react";

import bgImg from "../img/newsletter-bg.svg"
import bgMobImg from "../img/newsletter-br-mob.svg"

import "../style/newsletter.css"

function Newsletter() {
    return (
        <div className="newsletter-container">
            <img src={bgImg} alt="background" className="bg-image" />
            <img src={bgMobImg} alt="background" className="bg-image-mob" />
            <div className="text-wrapper">
                <b>Newsletter</b>
                <span>Receba conteúdos, notícias e materiais exclusivos sobre Educação Socioemocional e os Programas HUG.</span>
            </div>

            <form className="" onSubmit={e => e.preventDefault()}>
                <input type="text" name="nome" id="nome" placeholder="Seu Nome" />
                <input type="email" name="email" id="email" placeholder="seu@email.com" />
                <button type="submit">
                    <svg width="295" height="56" viewBox="0 0 295 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                        <path d="M284.104 50.8622C193.023 57.185 101.708 57.185 10.6273 50.8622C6.37099 50.5521 1.8709 46.4268 1.11882 41.7487C-0.372941 32.3881 -0.372941 23.2162 1.11882 13.8556C1.8709 9.1775 6.37099 5.05667 10.6273 4.7421C101.708 -1.5807 193.023 -1.5807 284.104 4.7421C288.36 5.05218 292.86 9.1775 293.612 13.8556C295.104 23.2162 295.104 32.3881 293.612 41.7487C292.86 46.4268 288.36 50.5476 284.104 50.8622Z" fill="#3498D4"/>
                    </svg>

                    <span>Assinar newsletter</span>
                    <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow">
                        <path d="M13.4951 14.1342C13.0672 13.7063 13.0672 13.0151 13.4951 12.5872L17.7411 8.31922H1.09718C0.493746 8.31922 2.3118e-05 7.8255 2.3118e-05 7.22206C2.3118e-05 6.61862 0.493746 6.1249 1.09718 6.1249H17.7411L13.4841 1.86792C13.0562 1.44002 13.0562 0.748812 13.4841 0.32092C13.912 -0.106973 14.6032 -0.106973 15.0311 0.32092L21.1752 6.45405C21.6031 6.88194 21.6031 7.57315 21.1752 8.00105L15.0421 14.1342C14.6142 14.5511 13.912 14.5511 13.4951 14.1342Z" fill="white"/>
                    </svg>
                </button>
            </form>
        </div>
    )
}

export default Newsletter